export default __webpack_public_path__ + "static/media/TimeClockFileBlue.3348b955.svg";